import { mapActions, mapState} from 'vuex';
import AppSelecionarClienteDialog from "./dialogs/SelecionarClienteDialog.vue";
import AppSelecionarUsuarioDialog from "./dialogs/SelecionarUsuarioDialog.vue";
import AppSelecionarImovelDialog from "../../shared/dialogs/SelecionarImovelDialog.vue";
import AppSelecionarAluguelDialog from "./dialogs/SelecionarAluguelDialog.vue";
import AppContratos from "../../alugueis/contratos/Contratos.vue";
import AppContratosVendas from "../../vendas/contratos/Contratos.vue";



import Util from "../../util/funcoes.js";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faKeyboard, faUserCircle, faCalendarCheck, faHome, } from '@fortawesome/free-solid-svg-icons';

library.add(faKeyboard, faUserCircle, faCalendarCheck, faHome);

export default {
  components: {
    AppSelecionarClienteDialog,
    AppSelecionarUsuarioDialog,
    AppSelecionarImovelDialog,
    AppSelecionarAluguelDialog,
    AppContratos,
    AppContratosVendas,
    FontAwesomeIcon
  },
  created() {
    this.logPesquisa.dataInicial = Util.primeiroDiaMes();
    this.logPesquisa.dataFinal = Util.ultimoDiaMes();
    this.pesquisarCreated();
  },
  data() {
    return {

      listaLogs: [],
      quantidadeLogs: 0,
      currentPageLogs: 1,
      
      infiniteLoadingId: 0,
      auxLogPesquisa: {
        dataInicial: undefined,
        dataFinal: undefined,
        texto: undefined,
        cliente: undefined,
        pagina: 0
      },
      visibilidadeSelecionarClienteDialog: false,
      visibilidadeSelecionarUsuarioDialog: false,
      visibilidadeSelecionarImovelDialog: false,
      visibilidadeSelecionarAluguelDialog: false,

      validacao: {
        dataInicial: [{ required: true }],
        dataFinal: [{ required: true }]
      },

      loadingClientes: false,
      loadingImovel: false,
      loadingUsuario: false,
      loadingAluguel: false,

      expandRowText: false,

      idsShowTextLogs: []
    }
  },
  computed: {
    ...mapState('logsAcessoStore', {
      logs(state) { return state.listaLogs },
      logPesquisa(state) { return state.logPesquisa },
      quantidadeTotalLogs(state) { return state.labelQuantidade },
      clientesDisponiveis(state) { return state.listaClientes },
      usuariosDisponiveis(state) { return state.listaUsuarios },
      imoveisDisponiveis(state) { return state.listaImoveis },
      alugueisDisponiveis(state) { return state.listaAlugueis }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),

    ...mapActions('loginStore', [
      'relogar',
    ]),
    
    ...mapActions("alugueisContratosStore", ["recuperarAluguel"]),
    ...mapActions("vendasImoveisStore", ["recuperarImovel"]),
    ...mapActions("vendasContratosStore", ["recuperarVenda"]),
    ...mapActions("alugueisClientesStore", ["recuperarClienteAluguel"]),
    ...mapActions('logsAcessoStore', [
      'listarLogs',
      'gerarRelatorioLogs',
      'limparLogsListados',
      'limparLogPesquisa',
      'limparCamposPesquisaData',
      'limparCampoCliente',
      'limparCampoUsuario',
      'limparCampoImovel',
      'limparCampoAluguel',
      'listarClientes',
      'listarUsuarios',
      'listarImoveis',
      'listarAlugueis'
    ]),
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },

    gerarRelatorio() {
      this.showLoading();
      const payload = {
        nome: 'RELATORIO_LOGS',
        logger: {
          ...this.auxLogPesquisa,
          pagina: this.currentPageLogs
        }
      }
      this.gerarRelatorioLogs(payload)
        .then((resultado) => {
         if(resultado.status == 'SUCESSO'){
           this.hideLoading();
        }
        if(resultado.status == 'FALHA'){
          this.hideLoading();
          this.$message.error("Não foi possível gerar relatório")
        }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    
    pesquisar() {
      this.showLoading();
      this.auxLogPesquisa = Object.assign({}, this.logPesquisa);
      this.validarEFormatarDatas();
      this.listarLogs(this.auxLogPesquisa)
        .then((resultado) => {
         this.listaLogs = resultado.lista;
         this.quantidadeLogs = resultado.quantidade;
         this.hideLoading();

        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    pesquisarHandler() {
      this.$refs['form'].validate(isValid => {
        const formIsNotValid = !isValid

        if(formIsNotValid) {
          this.$message.warning('Datas são obrigatórias.')
          return
        }

        if(!this.validarRangeData()) {
          this.exibirAlert('Atenção', 'Para melhor geração dos dados, pesquise por datas dentro de um período de 12 meses!')
          return
        }
        this.currentPageLogs = 1;
        this.logPesquisa.pagina = 0;
        this.limparLogsListados();
        this.pesquisar()
      });
    },

   
    labelQuantidadeLogs() {
      switch (this.listaLogs.length) {
          case 1:
              return `1 Log encontrado`
          case 0:
              return '';
          default:
              return `Exibindo ${(this.currentPageLogs - 1) * 100 + 1} a ${(this.currentPageLogs - 1) * 100 + this.listaLogs.length} de ${this.quantidadeTotalLogs}`
      }
    },

    handleCurrentChange() {
      this.logPesquisa.pagina = this.currentPageLogs - 1;
      this.pesquisar(); 
    },

    pesquisarCreated() {
      this.currentPageLogs = 1;
      this.limparLogsListados();
      this.pesquisar();
    },
    limparPesquisa() {
      this.limparLogPesquisa();
    },
    limparCamposData() {
      this.limparCamposPesquisaData();
    },
    validarEFormatarDatas() {
      if(
        !Util.validarData(this.logPesquisa.dataInicial) ||
        !Util.validarData(this.logPesquisa.dataFinal)
      ) {
        if(this.logPesquisa.dataInicial || this.logPesquisa.dataFinal) {
          this.$message.warning("Forneça uma data válida");
        }
        this.auxLogPesquisa.dataInicial = undefined;
        this.auxLogPesquisa.dataFinal = undefined;
        return;
      }
      this.auxLogPesquisa.dataInicial = Util.formatarData(this.auxLogPesquisa.dataInicial);
      this.auxLogPesquisa.dataFinal = Util.formatarData(this.auxLogPesquisa.dataFinal);
    },
    validarRangeData() {
      const inicio = Util.stringParaData(this.logPesquisa.dataInicial);
      const fim = Util.stringParaData(this.logPesquisa.dataFinal);

      if (Util.diffMeses(inicio, fim, true) <= 12) {
        return true;
      }
      return false;
    },
    validarClienteExclusao(item){
      return !(item.exclusaoLogica);
    },
    recuarMeses() {
      const dataInicial = Util.stringParaData(this.logPesquisa.dataInicial);
      const dataFinal = Util.stringParaData(this.logPesquisa.dataFinal);

      const periodoAtualDasDatas = Util.diffMeses(dataInicial, dataFinal, true)

      if(periodoAtualDasDatas <= 12) {
        this.logPesquisa.dataInicial = Util.dataParaString(Util.recuarPeriodoDaData(dataInicial, periodoAtualDasDatas));
        this.logPesquisa.dataFinal = Util.dataParaString(Util.recuarPeriodoDaData(dataFinal, periodoAtualDasDatas));
      }
      this.currentPageLogs = 1;
      this.logPesquisa.pagina = 0;
      this.pesquisar();
    },
    avancarMeses() {
      const dataInicial = Util.stringParaData(this.logPesquisa.dataInicial);
      const dataFinal = Util.stringParaData(this.logPesquisa.dataFinal);

      const periodoAtualDasDatas = Util.diffMeses(dataInicial, dataFinal, true);

      if(periodoAtualDasDatas <= 12) {
        this.logPesquisa.dataInicial = Util.dataParaString(Util.avançarPeriodoDaData(dataInicial, periodoAtualDasDatas));
        this.logPesquisa.dataFinal = Util.dataParaString(Util.avançarPeriodoDaData(dataFinal, periodoAtualDasDatas));
      }
      this.currentPageLogs = 1;
      this.logPesquisa.pagina = 0;
      this.pesquisar();
    },
    fecharSelecionarClienteDialog() {
      this.visibilidadeSelecionarClienteDialog = false;
    },
    exibirSelecionarClienteDialog() {
      this.visibilidadeSelecionarClienteDialog = true;
    },
    limparCliente() {
      this.limparCampoCliente();
    },

    fecharSelecionarUsuarioDialog() {
      this.visibilidadeSelecionarUsuarioDialog = false;
    },
    exibirSelecionarUsuarioDialog() {
      this.visibilidadeSelecionarUsuarioDialog = true;
    },

    fecharSelecionarImovelDialog(imovelSelecionado) {
      this.visibilidadeSelecionarImovelDialog = false;

      this.logPesquisa.imovel = imovelSelecionado;
    },
    exibirSelecionarImovelDialog() {
      this.visibilidadeSelecionarImovelDialog = true;
    },

    fecharSelecionarAluguelDialog() {
      this.visibilidadeSelecionarAluguelDialog = false;
    },
    exibirSelecionarAluguelDialog() {
      this.visibilidadeSelecionarAluguelDialog = true;
    },

    //FILTROS DOS SELECTS
    filtrarClientesSelect(queryString) {
      let payload = {};
      let reg = /^\d+$/;

      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString;
      this.loadingClientes = true
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        }).catch(() => {
          this.loadingClientes = false;
        });
    },

    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },

    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuario = true;
      this.listarUsuarios(payload)
        .then(() => {
          this.loadingUsuario = false;
        }).catch(() => {
          this.loadingUsuario = false;
        });
    },

    filtrarImoveisSelect(queryString) {
      let payload = {}

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.endereco = queryString;
      this.loadingImovel = true;
      this.listarImoveis(payload)
        .then(() => {
          this.loadingImovel = false;
        }).catch(() => {
          this.loadingImovel = false;
        });
    },
    formatarEnderecoImovel(imovel){
      return Util.formatarEnderecoImovel(imovel);
    },

    filtrarAlugueisSelect(queryString) {
      let payload = {
        idNaImobiliaria: queryString
      }

      this.loadingAluguel = true;
      this.listarAlugueis(payload)
        .then(() => {
          this.loadingAluguel = false;
        }).catch(() => {
          this.loadingAluguel = false;
        })
    },

    recuperarCliente(cliente) {
      let payload = { id: cliente.id };

      this.showLoading();
      this.recuperarClienteAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            this.$router.push("/alugueis/clientes");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
          this.hideLoading();
        });
    },

    recuperarContratoAluguel(aluguel) {
      let payload = { id: aluguel.id };

      this.showLoading();
      this.recuperarAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            this.$router.push("/alugueis");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
          this.hideLoading();
        });
    },

    recuperarContratoVenda(venda) {
      let payload = { id: venda.id };

      this.showLoading();
      this.recuperarVenda(payload)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            this.$router.push("/vendas");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
          this.hideLoading();
        });
    },

    recuperarImoveis(imovel) {
      const payload = { id: imovel.id };
      this.showLoading();
      this.recuperarImovel(payload)
        .then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$router.push("/imoveis");
              this.hideLoading();
              break;
            case "FALHA":
            case "ERRO":
              this.hideLoading();
              break;
          }
        }).catch(() => {
          this.hideLoading();
        })
    },

    recuperarHandler(row) {
      return row.cliente.id > 0 && this.validarClienteExclusao(row.cliente) ? this.recuperarCliente(row.cliente) : row.aluguel.id > 0 && row.imovel.id == 0  && row.aluguel.idNaImobiliaria ? this.recuperarContratoAluguel(row.aluguel) :
        row.imovel.id > 0 && row.aluguel.id > 0 || row.imovel.id > 0 ? this.recuperarImoveis(row.imovel) : row.venda.id > 0 ? this.recuperarContratoVenda(row.venda) : "";
    },

    labelButton(row) {
      return row.cliente.id > 0 ? row.cliente.nome : row.aluguel.id > 0 && row.imovel.id == 0 && row.aluguel.idNaImobiliaria ? `ID: ${row.aluguel.idNaImobiliaria}` :
        row.imovel.id > 0 && row.aluguel.id > 0 || row.imovel.id > 0 ? `ID: ${row.imovel.idNaImobiliaria}` : row.venda.id > 0 ? `ID: ${row.imovel.idNaImobiliaria}` : this.labelTooltip(row);
    },

    labelTooltip(row) {
      return row.cliente.id > 0 ? `Cliente: ${row.cliente.nome}` :
        row.aluguel.id > 0 && row.imovel.id == 0 ? 'Aluguel' :
        row.venda.id > 0 ? 'Venda' :
        row.imovel.id > 0 && row.aluguel.id > 0 || row.imovel.id > 0 ? 'Imóvel' : '';
    },

    showTextRow(id) {
      if(this.idsShowTextLogs.includes(id)) {
        const indice = this.idsShowTextLogs.indexOf(id);

        this.idsShowTextLogs.splice(indice, 1);
        return;
      }
      this.idsShowTextLogs.push(id);
    }
  }
};